export const PAX_MANIFEST_MARK_PASSENGER = 'PAX_MANIFEST_MARK_PASSENGER';

export default function markPassengerAction(passengerEntityId, checked) {
  return {
    type: PAX_MANIFEST_MARK_PASSENGER,
    passengerEntityId,
    checked,
  };
}
